interface WebGLRendererInfo {
    vendor?: string;
    renderer?: string;
}

export default function getWebGLRendererInfo(): WebGLRendererInfo {
    const info: WebGLRendererInfo = {};

    try {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('webgl');
        if (!context) return info;

        const debugContext = context.getExtension('WEBGL_debug_renderer_info');
        if (!debugContext) return info;

        info.vendor = context.getParameter(debugContext.UNMASKED_VENDOR_WEBGL);
        info.renderer = context.getParameter(debugContext.UNMASKED_RENDERER_WEBGL);
    } catch (ex) {
        console.error('getWebGLRendererInfo threw', ex);
    }

    return info;
}
